import React from 'react';
 
function Section({children}) {
 
   return <section className="container">{children}</section>
}
 
export default Section;